import Button from '@ui/Button'
import { InviteContentContainer, InviteText } from '@/styles/pages/Invite'
import Logo from '../assets/images/philosoph.svg'
import qr from '../assets/images/AIcodeQR.svg'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { BackArrowContainer } from '@shared/styles/ArrowStyles'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

export default function Invite() {
	const nav: UseIonRouterResult = useIonRouter()

	const goBackFunction = () => {
		if (nav.canGoBack()) {
			return nav.goBack()
		} else nav.push(ROUTES.overall.main)
	}

	return (
		<DefaultPage>
			<Content scrollY={false}>
				<BackArrowContainer>
					<BackArrowHeader style={{ width: 'auto' }} goBackFunction={goBackFunction} />
				</BackArrowContainer>
				<InviteContentContainer style={{ marginTop: '28px' }}>
					<img src={Logo} style={{ alignSelf: 'center' }} />
					<InviteText>
						Пригласите друзей
						<br /> и тренируйтесь вместе!
					</InviteText>
					<div style={{ alignSelf: 'center' }}>
						<img src={qr} />
					</div>
				</InviteContentContainer>
			</Content>
			<Button background={'#DCF831'} color={'black'} border_radius={'22px'} width={'80%'}>
				Скопировать ссылку
			</Button>
		</DefaultPage>
	)
}
